import { TaskTagsInputController } from './task-tags-input.controller'

function taskTagsInput () {
  return {
    restrict: 'E',
    scope: {
      task: '=',
      autoSave: '<',
      new: '<'
    },
    templateUrl: '/workflow/directives/task-tags-input/task-tags-input-directive.html?$$REVISION$$',
    controller: TaskTagsInputController
  }
}

export { taskTagsInput }
